import React from 'react';
import PropTypes from 'prop-types';
import Moment from 'moment'
import 'moment/locale/sk';
import 'moment/locale/cs';
import 'moment/locale/de';
import 'moment/locale/en-gb';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Route, Switch } from 'react-router';
import { withLocalize } from "react-localize-redux";
import { renderToStaticMarkup } from "react-dom/server";

import { appContextActions } from './store/appContextStore'
import { getLanguage } from './store/apiWrapper';

import PrivateRoute from './components/common/privateRoute'
import Layout from './components/layoutItems/layout';
import LoginComponent from './components/loginComponent';
import NotAuthorizedComponent from './components/notAuthorizedComponent';
import NotFoundComponent from './components/notFoundComponent';
import LogoutComponent from './components/logoutComponent';
import HomeComponent from './components/homeComponent';
import SettingsComponent from './components/settingsComponent';
import LostPwdComponent from './components/lostPwdComponent';

import TableauComponent from './components/tableau/tableauComponent'

import 'moment/locale/sk';
import 'moment/locale/cs';
import 'moment/locale/de';

const onMissingTranslation = ({ translationId }) => `-${translationId}-`;
const momentLocaleMap = { "sk-SK": "sk", "cs-CZ": "cs", "en-US": "en-gb", "de-DE": "de" };

class App extends React.Component {
  constructor(props) {
    super(props);

    const defLang = getLanguage();
    this.props.initialize({
        languages: [
            { name: "Slovensky", code: "sk-SK" },
            { name: "Česky", code: "cs-CZ" },
            { name: "Deutsch", code: "de-DE" },
            { name: "English", code: "en-US" }
        ],
        options: { onMissingTranslation, defaultLanguage: defLang, renderToStaticMarkup }
    });
    Moment.locale(momentLocaleMap[defLang] || 'sk');
    this.props.fetchTranslations(defLang, this.props.addTranslationForLanguage);
  }

  render() {
      return (
          <React.Fragment>
              <noscript>
                  You need to enable JavaScript to run this app.
              </noscript>
              <Layout>
                  <Switch>
                    <Route exact path='/' component={HomeComponent} />
                    <PrivateRoute exact path='/settings' component={SettingsComponent} />
                    <Route exact path="/login" component={LoginComponent} />
                    <Route exact path="/lost-password" component={LostPwdComponent} />
                    <Route exact path="/notAuthorized" component={NotAuthorizedComponent} />
                    <Route exact path="/notFound" component={NotFoundComponent} />
                    <Route exact path="/logout" component={LogoutComponent} />
                     <PrivateRoute exact path='/tableau' component={TableauComponent} />
                  </Switch>
              </Layout>
          </React.Fragment>
      );
  };
}

App.propTypes = {
  fetchTranslations: PropTypes.func.isRequired
};

export default withLocalize(connect(
  state => state.appContext,
  dispatch => bindActionCreators(appContextActions, dispatch)
)(App));